export const extractErrorMessage = (
  error: unknown,
  defaultMessage: string,
): string => {
  if (error && typeof error === "object") {
    if ("response" in error) {
      const axiosError = error as {
        response?: { data?: { message?: string | string[] } };
      };
      const message = axiosError.response?.data?.message;
      if (Array.isArray(message)) {
        return message.join(", ");
      }
      if (typeof message === "string") {
        return message;
      }
    }

    if ("message" in error && error.message !== null) {
      const message = (error as { message: string | string[] }).message;
      if (Array.isArray(message)) {
        return message.join(", ");
      }
      if (typeof message === "string") {
        return message;
      }
    }
  }
  return defaultMessage;
};
